import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import specialFeatureService from "../../../services/special-feature.service";


const initialValues = {
  name: "",
};
const schema = Yup.object().shape({
  name: yupSchema.name,
  color: yupSchema.optionalColorHex,
});
const form = [
  {
    _type: "textField",
    name: "name",
    label: "نام ویژگی خاص",
    autoFocus: true,
  }
];

export default function FormModalContent({ close, data, extra }) {
  const errorHandler = useErrorHandler();

  const handleSubmit = async (model, { setSubmitting }) => {
    let op;
    if (data?.id) {
      op = await specialFeatureService.editSpecialFeature(data.id, model);
    } else {
      op = await specialFeatureService.createSpecialFeature(model);
    }
    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };
  return (
    <DialogFormBuilder
      {...{
        close,
        name: "ویژگی خاص",
        data,
        schema,
        initialValues,
        handleSubmit,
        form,
      }}
    />
  );
}
